import React from 'react'
import CoinsTable from '../components/CoinsTable'
import Hero from '../components/Hero'

const Homepage = () => {
    return (
        <>
            <Hero />
            <CoinsTable />
        </>
    )
}

export default Homepage
